/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { partitionsUpdate } from "../../funcs/partitionsUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.UpdatePartitionPartitionsPartitionIdPatchRequest$inboundSchema,
};

export const tool$partitionsUpdate: ToolDefinition<typeof args> = {
  name: "partitions-update",
  description: `Update Partition

Updates a partition. This includes the partition's description and metadata schema.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await partitionsUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
